import authStore from 'src/states/auth/auth';

import { combineReducers } from 'redux';

const reducers = combineReducers({
  auth: authStore.reducer,
});

export default reducers;
